export default "__VITE_ASSET__CzKyd7UM__"